import * as Yup from 'yup';
import { getTomorrowDate } from '../../../utils/dates';
import {
  YupEditorMaxLengthValidator,
  YupEditorMinLengthValidator,
} from '../../../utils/validators';
import { DEFAULT_AVAILABLE_ROLES } from '../../../utils/registrationRoles';
YupEditorMaxLengthValidator();
YupEditorMinLengthValidator();

export const ALLOWED_CHAR = 60;
export const ALLOWED_DESCRIPTION_CHAR = 200;
export const ALLOWED_ITEMS_CHAR = 100;
export const MOBILE_WELCOME_MESSAGE_MAX_LENGTH = 60;
export const PROGRAM_DESCRIPTION_MAX_LENGTH = 500;

const availableRolesSchema = Yup.array()
  .of(Yup.string().oneOf(DEFAULT_AVAILABLE_ROLES))
  .min(1, 'Debes seleccionar al menos un rol disponible')
  .required('Debes seleccionar al menos un rol disponible');

const registrationConfigurationSchema = Yup.object().shape({
  availableRoles: availableRolesSchema,
});

export const landingSchema = Yup.object().shape({
  configuration: Yup.object()
    .shape({
      registration: registrationConfigurationSchema.required(),
    })
    .required(),
  title: Yup.string()
    .max(
      ALLOWED_CHAR,
      `El largo máximo para el título son de ${ALLOWED_CHAR} caracteres`
    )
    .trim()
    .required('Debes ingresar un titulo para la convocatoria'),
  // startDate: Yup.date().min(getTomorrowDate(),'La fecha de registro debe ser desde mañana').required(
  //   'Debes ingresar una fecha de inicio de registro.'
  // ),
  startDate: Yup.date().required(
    'Debes ingresar una fecha de inicio de registro.'
  ),
  endDate: Yup.date().required('Debes ingresar una fecha de termino.'),
  loginPrimaryColor: Yup.string().required(
    'Debes ingresar un color primario para el login y registro'
  ),
  loginSecondaryColor: Yup.string().required(
    'Debes ingresar un color secundario para el login y registro'
  ),
  mobileWelcomeMessage: Yup.string()
    .max(
      MOBILE_WELCOME_MESSAGE_MAX_LENGTH,
      `El largo máximo para la bajada es de ${MOBILE_WELCOME_MESSAGE_MAX_LENGTH} caracteres`
    )
    .required('Debes ingresar la bajada de la convocatoria'),
  about: Yup.string().editorMaxLengthValidator(
    PROGRAM_DESCRIPTION_MAX_LENGTH,
    `El largo máximo para la descripción son ${PROGRAM_DESCRIPTION_MAX_LENGTH} caracteres`
  ),
});

export const landingEditSchema = Yup.object().shape({
  title: Yup.string()
    .max(
      ALLOWED_CHAR,
      `El largo máximo para el título son de ${ALLOWED_CHAR} caracteres`
    )
    .trim()
    .required('Debes ingresar un titulo para la convocatoria'),
  startDate: Yup.date().required(
    'Debes ingresar una fecha de inicio de registro.'
  ),
  endDate: Yup.date().required('Debes ingresar una fecha de termino.'),
  urlMentee: Yup.string()
    .matches(
      /^[a-z0-9]+(?:-[a-z0-9]+)*$/,
      'Debes ingresar una URL para registro mentee, no se aceptan caracteres especiales'
    )
    .required('Debes ingresar una URL para registro mentee'),
  urlMentor: Yup.string()
    .matches(
      /^[a-z0-9]+(?:-[a-z0-9]+)*$/,
      'Debes ingresar una URL para registro mentor, no se aceptan caracteres especiales'
    )
    .required('Debes ingresar una URL para registro mentor'),
  logo: Yup.string().required('Debes ingresar una imágen válida'),
  mobileWelcomeMessage: Yup.string()
    .max(
      MOBILE_WELCOME_MESSAGE_MAX_LENGTH,
      `El largo máximo para la bajada es de ${MOBILE_WELCOME_MESSAGE_MAX_LENGTH} caracteres`
    )
    .required('Debes ingresar la bajada de la convocatoria'),
});
